import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  IFormbuilderFieldTypeConfiguration,
  ICustomIdInputFieldSettingsModel,
} from '../../../models/form-builder-types-configurations.model';
import {
  baseFieldUpdateFromSettingsFormModel,
  populatesPropsParseIntoSettingsFormModel,
  populatesPropsUpdateFromSettingsFormModel,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { IFormFieldsValidationModel } from '../../../models/form-fields-formly-validation.model';
import {
  parsePopulatesFieldValidatorFormDataIntoModel,
  parseRequiredValidatorParseFieldIntoModel,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-parse-to-model.util';
import {
  setRequiredValidatorUpdateFieldFromModel,
  setPopulatesFieldValidatorFormDataIntoField,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-set-from-model.util';
import { FormBuilderService } from '../../../services/form-builder.service';
import { IFormFieldsDisplayModel } from '../../../models/form-fields-formly-display.model';
import { parseFieldIntoDisplayFormModel } from '../form-fields-formly-display/form-fields-formly-display-field-parse-to-model.util';
import { setDisplayHideExpressionFromModel } from '../form-fields-formly-display/form-fields-formly-display-field-set-from-model.util';
import { getGenericCustomIdFieldTypeconfigurationConfig } from './shared.configuration';
import { ninIdResponseProps } from '../../../models/custom-id-input-responses.model';

export const ninFieldGetConfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  const config = getGenericCustomIdFieldTypeconfigurationConfig(
    formBuilderServiceInstance,
    [...Array.from(ninIdResponseProps)]
  );

  config.settings.formlyForm = [
    ...config.settings.formlyForm,
    {
      key: 'mixpanelEventAnalyticsConfig',
      id: 'mixpanelEventAnalyticsConfig',
      type: 'formly-group',
      props: { dragDisabled: false },
      fieldGroup: [
        {
          key: 'mixpanelEventAnalytics',
          type: 'checkbox',
          defaultValue: false,
          props: { label: 'Enable MixPanel Analytics', formCheck: 'switch' },
        },
      ],
    },
  ];

  return config;
};

export const ninFieldParseIntoSettingsFormModel = (
  ninFieldField: FormlyFieldConfig
): ICustomIdInputFieldSettingsModel => {
  const model = populatesPropsParseIntoSettingsFormModel(ninFieldField);
  model.mixpanelEventAnalyticsConfig = {
    mixpanelEventAnalytics: ninFieldField.props?.['mixpanelEventAnalytics'],
  };
  return model;
};

export const ninFieldUpdateFromSettingsFormModel = (
  model: ICustomIdInputFieldSettingsModel,
  ninFieldField: FormlyFieldConfig
): FormlyFieldConfig => {
  ninFieldField = baseFieldUpdateFromSettingsFormModel(model, ninFieldField);
  ninFieldField = populatesPropsUpdateFromSettingsFormModel(
    model,
    ninFieldField
  );

  ninFieldField.props = {
    ...(ninFieldField.props ?? {}),
    mixpanelEventAnalytics:
      model.mixpanelEventAnalyticsConfig?.mixpanelEventAnalytics,
  };

  return ninFieldField;
};

export const ninFieldParseIntoValidationFormModel = (
  ninFieldField: FormlyFieldConfig
): IFormFieldsValidationModel => {
  let model: IFormFieldsValidationModel = {};

  model = parseRequiredValidatorParseFieldIntoModel(model, ninFieldField);
  model = parsePopulatesFieldValidatorFormDataIntoModel(model, ninFieldField);

  return model;
};

export const ninFieldUpdateFromValidationFormModel = (
  model: IFormFieldsValidationModel,
  ninFieldField: FormlyFieldConfig
): FormlyFieldConfig => {
  ninFieldField = setRequiredValidatorUpdateFieldFromModel(
    model,
    ninFieldField
  );
  ninFieldField = setPopulatesFieldValidatorFormDataIntoField(
    model,
    ninFieldField
  );

  return ninFieldField;
};

export const ninFieldParseFieldIntoDisplayFormModel = (
  ninFieldField: FormlyFieldConfig
): IFormFieldsDisplayModel => {
  return parseFieldIntoDisplayFormModel(ninFieldField);
};

export const ninFieldUpdateFromDisplayFormModel = (
  model: IFormFieldsDisplayModel,
  ninFieldField: FormlyFieldConfig
): FormlyFieldConfig => {
  return setDisplayHideExpressionFromModel(model, ninFieldField);
};
